'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var R = require('ramda');
var websockets = require('@rushplay/websockets');
var redux = require('redux');
var reactRedux = require('react-redux');
var PropTypes = _interopDefault(require('prop-types'));

/**
 * @constant
 */
var ADDED = 'notifications/ADDED';
/**
 * @constant
 */

var DISMISSED = 'notifications/DISMISSED';
/**
 * @constant
 */

var DISMISSED_ALL = 'notifications/DISMISSED_ALL';

/**
 * Notification severity level
 *
 * @readonly
 * @enum {string}
 */
var NotificationLevel = {
  /**
   * Unexpected failure requiring further action to prevent data loss or
   * undesired behaviour (e.g. form submission failure due to server error,
   * deposit failure due to authentication error)
   */
  ERROR: 'error',

  /**
   * Neutral messages with any kind of information, e.g. new inventory items,
   * new games available.
   */
  INFO: 'info',

  /**
   * Positive reaction on player’s action, e.g. form submission.
   */
  SUCCESS: 'success',

  /**
   * Negative message to inform player about issues that do not require
   * immediate action, e.g. log out due to session limits or message about game
   * provider unavailability.
   */
  WARNING: 'warning'
};

/**
 * Notification.
 *
 * @typedef {Object} Notification
 * @property {?string} [context] Optional notification context (e.g. `dev` or
 * `commercial`); used to display notifications conditionally.
 * @property {Level} level Notification severity level; used to style and
 * display notifications conditionally.
 * @property {string} message Translation key
 * @property {?Object} [variables] Translation variables
 */

/**
 * Adds notification.
 *
 * @param {Notification} payload
 * @returns {Object} Redux action
 */

function add(payload) {
  if (R.not(R.contains(payload.level, R.values(NotificationLevel))) || R.isNil(payload.message)) {
    var levels = R.join(', ', R.values(NotificationLevel)); // eslint-disable-next-line no-console

    console.error("'level' must be one of: ".concat(levels, "."));
    return {
      type: 'NOOP'
    };
  }

  if (typeof payload.message !== 'string') {
    // eslint-disable-next-line no-console
    console.error("'message' must be a string.");
    return {
      type: 'NOOP'
    };
  }

  if (R.isEmpty(payload.message)) {
    // eslint-disable-next-line no-console
    console.error("'message' is required in payload.");
    return {
      type: 'NOOP'
    };
  }

  return {
    type: ADDED,
    payload: payload
  };
}
/**
 * Removes notification.
 *
 * @param {number} index Notification’s index
 * @returns {Object} Redux action
 */

function dismiss(index) {
  return {
    type: DISMISSED,
    payload: index
  };
}
/**
 * Removes all notifications.
 *
 * @returns {Object} Redux action
 */

function dismissAll() {
  return {
    type: DISMISSED_ALL
  };
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.error) {
    return reducer(state, add({
      level: NotificationLevel.ERROR,
      message: action.payload.message,
      variables: action.payload.variables
    }));
  }

  switch (action.type) {
    case ADDED:
      {
        var nextState = R.reduce(function (nextState, notification) {
          return R.path(['message'], notification) === action.payload.message ? reducer(state, dismiss(notification.id)) : state;
        }, state, state);
        return R.append(R.mergeDeepRight(action.payload, {
          id: state.length
        }), nextState);
      }

    case DISMISSED:
      {
        return R.update(action.payload, null, state);
      }

    case websockets.SESSION_EXPIRED:
    case DISMISSED_ALL:
      {
        return [];
      }

    default:
      {
        return state;
      }
  }
}

/**
 * Get all notification IDs.
 *
 * @param {Object} state
 * @returns {Array<Notification>} list of notification ids
 */

function getAll(state) {
  return R.reject(R.isNil, R.pluck('id', state));
}
/**
 * Get notification.
 *
 * @param {Object} state
 * @param {Object} props
 * @param {string} props.id Notification ID
 * @returns {Notification} notification by id
 */

function getOne(state, props) {
  return state[props.id];
}

function Notification(props) {
  return props.children(R.merge(props.notification, {
    onDismiss: props.onDismiss
  }));
}
Notification.propTypes = {
  children: PropTypes.func,
  id: PropTypes.number,
  notification: PropTypes.object,
  mountPoint: PropTypes.string.isRequired
};

function mapStateToProps(state, props) {
  var notificationsState = R.prop(props.mountPoint, state);
  return {
    notification: getOne(notificationsState, {
      id: props.id
    })
  };
}

function mapDispatchToProps(dispatch) {
  return redux.bindActionCreators({
    onDismiss: dismiss
  }, dispatch);
}

var Notification$1 = reactRedux.connect(mapStateToProps, mapDispatchToProps)(Notification);

function Notifications(props) {
  return props.children(props.notifications);
}
Notifications.propTypes = {
  children: PropTypes.func,
  notifications: PropTypes.array
};

function mapStateToProps$1(state, props) {
  var notificationsState = R.prop(props.mountPoint, state);
  return {
    notifications: getAll(notificationsState)
  };
}

var Notifications$1 = reactRedux.connect(mapStateToProps$1)(Notifications);

exports.ADDED = ADDED;
exports.DISMISSED = DISMISSED;
exports.DISMISSED_ALL = DISMISSED_ALL;
exports.Notification = Notification$1;
exports.NotificationLevel = NotificationLevel;
exports.Notifications = Notifications$1;
exports.add = add;
exports.dismiss = dismiss;
exports.dismissAll = dismissAll;
exports.getAll = getAll;
exports.getOne = getOne;
exports.reducer = reducer;
//# sourceMappingURL=index.js.map
